<template>
  <div :class="{'card col-md-12': !wallet}" >
    <div v-if="!wallet" class="card-header">
      <h4 class="card-title">
        Sharing Center
      </h4>
    </div>
    <div class="card-content form-horizontal">
      <p>Your verification{{wallet ? ' wallet' : ''}} can be shared with third parties who are interested in the result.</p>
      <p v-if="wallet">Only Verified results from your wallet will be visible to third parties you share it with.</p>
      <div v-if="applications && applications.length > 0">
        <p><b>Applications</b></p>
        <p>Your verification(s) form part of an application to a third party institute or company. All staff registered with Qualification Check at that orangisation will have access to your verification(s) as part of your application to them. A list of your applications is shown below.</p>
        <el-table class="table table-striped table-no-bordered table-hover"
                  :data="applications"
                  size="mini"
                  style="width: 100%">
          <span slot="empty">No applications made.</span>
          <el-table-column label="Application Date"><template slot-scope="props">{{formatDate(props.row.created)}}</template></el-table-column>
          <el-table-column label="Organisation"><template slot-scope="props">{{props.row.owner.name}}</template></el-table-column>
          <el-table-column label="Verifications included"><template slot-scope="props">{{props.row.verificationCount}}</template></el-table-column>
        </el-table>
      </div>
      <hr />
      <p><b>Private sharing</b></p>
      <p>You can share your verification{{wallet ? ' wallet' : ''}} privately with select individuals by providing their email address below. They will be required to register with Qualification Check, if they have not already done so, and your verification{{wallet ? 's' : ''}} will be visible in their account. Only the owner of the email address entered will be able to register to access your verification{{wallet ? 's' : ''}}. A list of registered Qualification Check users with access to your verification{{wallet ? 's' : ''}} is shown below. You may revoke access to your verification{{wallet ? 's' : ''}} from any of the users at any time.</p>
      
      <el-table class="table table-striped table-no-bordered table-hover"
        :data="privateShares"
        size="mini"
        style="width: 100%">
        <span slot="empty">This verification{{wallet ? ' wallet' : ''}} is not being privately shared with anyone.</span>
        <el-table-column label="Email"><template slot-scope="props">{{props.row.key}}</template></el-table-column>
        <el-table-column label="Details">
          <template slot-scope="props">
            <span v-if="props.row.extra">Registered as {{props.row.extra}}.</span>
            <span v-else>Invited, not yet registered.</span>
          </template>
        </el-table-column>
        <el-table-column label="Date Shared"><template slot-scope="props">{{formatDate(props.row.created)}}</template></el-table-column>
        <el-table-column fixed="right" align="right">
          <template slot-scope="props">
            <button @click.prevent="deleteShare(props.row, true)" class="btn btn-xs"><i class="fa fa-trash" aria-hidden="true"></i>Delete</button>
          </template>
        </el-table-column>
      </el-table>
      <p><button @click.prevent="addShare" class="btn btn-fill btn-wd"><i class="fa fa-plus" aria-hidden="true"></i>Privately share</button></p>
      <hr/>
      <p><b>Public sharing</b></p>
      <!--
      <div key="NOTICES" class="row">
        <div class="col-sm-12">
          <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message">NOTICE: Public sharing of results has been retired as of Feb 3rd, 2025. Please use private sharing instead.</span>
          </div>
        </div>
      </div>
      -->
      <p>Alternatively, you can share your verification{{wallet ? ' wallet' : ''}} publicly by generating a link below. <b>Anyone</b> who obtains the link will be able to view your verification{{wallet ? ' wallet' : ''}} without registering with Qualification Check. This includes anyone you share the link with and anyone they forward the link onto. You may delete the link at any time if you believe it is being misused.</p>
      <p v-if="!publicShares || publicShares.length < 1"><button @click.prevent="generateShare" class="btn btn-fill btn-wd"><i class="fa fa-refresh" aria-hidden="true"></i>Generate public sharing link</button></p>
      <p v-else>
        <input type="hidden" :value="$service.buildURL('/view/' + publicShares[0].key)" id="publicShareValue">
        <b>Public sharing link: </b>
        <a :href="$service.buildURL('/view/' + publicShares[0].key)" target="_blank">{{$service.buildURL('/view/' + publicShares[0].key)}}</a>
        &nbsp;&nbsp;&nbsp;<button @click.prevent="copyToClip" class="btn"><i class="fa fa-clipboard" aria-hidden="true"></i>Copy</button>
        &nbsp;&nbsp;&nbsp;<button @click.prevent="deleteShare(publicShares[0], false)" class="btn"><i class="fa fa-trash" aria-hidden="true"></i>Delete</button>
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ModalOptions from 'src/components/ModalPlugin/ModalOptions'
import ModalPrivateShare from 'src/components/ModalPlugin/ModalPrivateShare'
export default {
    name: "sharing-center",
    components: {
    },
    props: {
      verification: {type: Object, default: null},
      wallet: {type: Boolean, default: false}
    },
    data () {
      return {
        shares: [],
        applications: null
      }
    },
    computed: {
      privateShares () {
        return this.shares ? this.shares.filter(share => share.type == 'PRIVATE') : []
      },
      publicShares () {
        return this.shares ? this.shares.filter(share => share.type == 'PUBLIC') : []
      }
    },
    mounted () {
      this.loadShares()
      this.$api.getApplicationHistory({size:1000})
            .then(response => {
              this.applications = response.data.content
            })
            .catch(error => {
              console.log(error)
            })
    },
    methods: {
      formatDate (timestamp) {
        var m = moment(timestamp)
        return m.format('DD MMM YYYY')
      },
      loadShares() {
        if(this.wallet) {
          this.$api.getWalletShares()
            .then(response => {
              this.shares = response.data
            })
            .catch(error => {
              console.log(error)
            })
        }
        else if(this.verification == null) {
          this.shares = []
        } else {
          this.$api.getVerificationShares(this.verification.id)
            .then(response => {
              this.shares = response.data
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      addShare() {
        this.$modal.show(ModalPrivateShare,
              {
                wallet: this.wallet,
                action: (value) => 
                  {
                    if(this.wallet) {
                      this.$api.postWalletShare({
                        key: value,
                        type: 'PRIVATE'
                      })
                      .then(response => {
                        this.loadShares()
                        this.$modal.close()
                        this.$snotify.success("Private share added.", "Success")
                      })
                      .catch(error => {
                        console.log(error)
                        this.$modal.close()
                      })
                    } else {
                      this.$api.postVerificationShare(this.verification.id, {
                        key: value,
                        type: 'PRIVATE'
                      })
                      .then(response => {
                        this.loadShares()
                        this.$modal.close()
                        this.$snotify.success("Private share added.", "Success")
                      })
                      .catch(error => {
                        console.log(error)
                        this.$modal.close()
                      })
                    }
                  }
              })
      },
      deleteShare(share, priv) {
        var m = priv ? "Are you sure you want to delete this private share? User " + share.key + " will no longer be able to view your verification" + (this.wallet ? " wallet" : " result") : "Are you sure you want to delete this public share? Nobody will be able to view your verification" + (this.wallet ? " wallet" : " result") + " any longer."
        this.$modal.show(ModalOptions,
          {
            title: "Delete",
            message: m,
            closeText: "Cancel",
            actionText1: "Delete",
            actionIcon1: "fa fa-trash",
            action1: () => 
            {
              if(this.wallet) {
                this.$api.deleteWalletShare(share.id)
                  .then(response => {
                    this.loadShares()
                    this.$modal.close()
                    this.$snotify.success("Share deleted.", "Success")
                  })
                  .catch(error => {
                    console.log(error)
                    this.$modal.close()
                  })
              } else {
                this.$api.deleteVerificationShare(this.verification.id, share.id)
                  .then(response => {
                    this.loadShares()
                    this.$modal.close()
                    this.$snotify.success("Share deleted.", "Success")
                  })
                  .catch(error => {
                    console.log(error)
                    this.$modal.close()
                  })
              }
            }
          }
        )
      },
      generateShare() {
        this.$modal.show(ModalOptions,
              {
                title: "Add Public Share",
                message: "Are you sure you want to add a public sharing url? Anyone with this url will be able to view your verification" + (this.wallet ? " wallet" : "") +". You can delete it any time.",
                closeText: "Cancel",
                actionText1: "Add",
                actionIcon1: "fa fa-refresh",
                action1: () => 
                  {
                    if(this.wallet) {
                      this.$api.postWalletShare({
                        type: 'PUBLIC'
                      })
                      .then(response => {
                        this.loadShares()
                        this.$modal.close()
                        this.$snotify.success("Public share added.", "Success")
                      })
                      .catch(error => {
                        console.log(error)
                        this.$modal.close()
                      })
                    } else {
                      this.$api.postVerificationShare(this.verification.id, {
                        type: 'PUBLIC'
                      })
                      .then(response => {
                        this.loadShares()
                        this.$modal.close()
                        this.$snotify.success("Public share added.", "Success")
                      })
                      .catch(error => {
                        console.log(error)
                        this.$modal.close()
                      })
                    }
                  }
              })
      },
      copyToClip() {
        var copyText = document.getElementById("publicShareValue")
        copyText.setAttribute("type", "input");
        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
        /* Copy the text inside the text field */
        document.execCommand("copy");
        copyText.setAttribute("type", "hidden");
        /* Alert the copied text */
        this.$snotify.success("Copied to clipboard");
      }
    }
}
</script>